export default function Cart() {
  let IdBlock3 = document.querySelector("#block-cart-3");
  if (IdBlock3) {
    IdBlock3.classList.add("banner");
    IdBlock3.classList.add("banner-template-two");
  }
}